import {BrowserModule} from '@angular/platform-browser';
import {ErrorHandler, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import {AmplifyAngularModule, AmplifyService} from 'aws-amplify-angular';
import {AppRoutingModule} from './app-routing.module';
import {ModalModule} from 'ngx-bootstrap/modal';
import {NgxCurrencyModule} from 'ngx-currency';
import {AppComponent} from './app.component';
import {LoginComponent} from './login/login.component';
import {SignUpComponent} from './sign-up/sign-up.component';
import {NotFoundComponent} from './not-found/not-found.component';
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import {VerificationComponent} from './verification/verification.component';
import {ForgotPasswordComponent} from './forgot-password/forgot-password.component';
import {PrivateConditionsComponent} from './sign-up/modals/private-conditions/private-conditions.component';
import {GooglePrivateConditionsComponent} from './sign-up/modals/google-private-conditions/google-private-conditions.component';
import {LoaderComponent} from './loader/loader.component';
import {LoaderInterceptorService} from './_interceptors/loader.interceptor';
import {AuthorizeComponent} from './authorize/authorize.component';
import {ServiceWorkerModule} from '@angular/service-worker';
import {environment} from '../environments/environment';
import {CookieService} from 'ngx-cookie-service';
import {RedirectComponent} from './redirect/redirect.component';
import {CommonModule} from '@angular/common';
import {LogoutComponent} from './logout/logout.component';
import {ChangePasswordComponent} from './change-password/change-password.component';
import {AuthGuard} from './_guard/auth.guard';
import {RecaptchaModule, RecaptchaFormsModule, RECAPTCHA_SETTINGS, RecaptchaSettings} from 'ng-recaptcha';
import { LogingService } from './_services/loging.service';
import { ErrorHandlerService } from './_interceptors/error.Handler';

const globalSettings: RecaptchaSettings = { siteKey: environment.recaptchaKey };


export const customCurrencyMaskConfig = {
  align: 'right',
  allowNegative: false,
  allowZero: true,
  decimal: ',',
  precision: 0,
  prefix: '$',
  suffix: '',
  thousands: '.',
  nullable: true
};

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        RedirectComponent,
        SignUpComponent,
        NotFoundComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
        VerificationComponent,
        PrivateConditionsComponent,
        GooglePrivateConditionsComponent,
        LoaderComponent,
        AuthorizeComponent,
        LogoutComponent,
        ChangePasswordComponent
    ],
    imports: [
        BrowserModule,
        RecaptchaModule,
        RecaptchaFormsModule,
        CommonModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        AmplifyAngularModule,
        NgxCurrencyModule.forRoot(customCurrencyMaskConfig),
        ModalModule,
        ModalModule.forRoot(),
        ServiceWorkerModule.register('ngsw-worker.js', {enabled: environment.production})
    ],
    providers: [
        AmplifyService,
        CookieService,
        LogingService,
        AuthGuard,
        {provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptorService, multi: true},
        {provide: RECAPTCHA_SETTINGS, useValue: globalSettings},
        { provide: ErrorHandler, useClass: ErrorHandlerService }

    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
